





























































import { Component, Prop, Vue } from 'vue-property-decorator';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';
import { formatToTimeZone } from 'date-fns-timezone';

@Component({})
export default class TicketHeader extends Vue {
  @Prop(Boolean) public readonly isPublicApp!: boolean;
  @Prop(Object) public readonly event!: any;
  @Prop(Object) public readonly ticketEmbedSettings!: any;

  private get widgetSettings() {
    const defaults = {
      showEventBanner: true,
      showEventTime: true,
      showEventLocation: true,
      showEventImage: true,
      showEventDescription: true,
      theme: 'light',
    };
    return this.isPublicApp ? defaults : this.ticketEmbedSettings;
  }

  public formatDates(firstDate, secondDate, timezone) {
    secondDate = secondDate || '';
    timezone = timezone || 'UTC';

    const startTime = formatToTimeZone(new Date(firstDate), 'hh:mm a', {
      timeZone: timezone,
    });

    const endTime = formatToTimeZone(new Date(secondDate), 'hh:mm a (z)', {
      timeZone: timezone,
    });

    const startDate = format(new Date(firstDate), 'eee, MMM d');
    const endDate = format(new Date(secondDate), 'eee, MMM d, yyyy');

    if (isSameDay(new Date(firstDate), new Date(secondDate))) {
      return `${startDate} ${startTime} - ${endTime}`;
    }

    return `${startDate} ${startTime} - ${endDate} ${endTime}`;
  }
}
